import Collection from '../utils/Collection';
import Message from '../utils/Message';
import {
  FETCH_MESSAGES_SENT,
  FETCH_MESSAGES_SUCCEEDED,
  FETCH_MESSAGES_FAILED,
  LOAD_MORE_MESSAGES_SENT,
  LOAD_MORE_MESSAGES_SUCCEEDED,
  LOAD_MORE_MESSAGES_FAILED,
  SEND_MESSAGE_SENT,
  SEND_MESSAGE_SUCCEEDED,
  SEND_MESSAGE_FAILED,
  MARK_MESSAGE_READ_SENT,
  // MARK_MESSAGE_READ_SUCCEEDED,
  // MARK_MESSAGE_READ_FAILED,
  RECEIVED_NEW_MESSAGE,
  MESSAGE_READ_BY_SOMEONE,
} from '../actions/message';

const getMessageObjs = (messages) => {
  let messageObjs = [];
  for (let message of messages) {
    messageObjs.push(new Message(message));
  }
  return messageObjs;
};

const initialState = {
  messages: [],
  loading: false,
  saving: false,
};

export default function messageReducer(state = initialState, action) {
  const { payload, type } = action;
  let messageObj, messageObjs;
  switch (type) {
    case FETCH_MESSAGES_SUCCEEDED:
    case LOAD_MORE_MESSAGES_SUCCEEDED:
      messageObjs = getMessageObjs(payload.messages);
      return {
        ...state,
        loading: false,
        messages: Collection.add(state.messages, messageObjs),
      };
    case FETCH_MESSAGES_SENT:
    case LOAD_MORE_MESSAGES_SENT:
      return {
        ...state,
        loading: true,
      };
    case FETCH_MESSAGES_FAILED:
    case LOAD_MORE_MESSAGES_FAILED:
      return {
        ...state,
        loading: false,
      };
    case SEND_MESSAGE_SENT:
      return {
        ...state,
        messages: Collection.add(state.messages, payload.messageObj),
        saving: true,
      };
    case SEND_MESSAGE_SUCCEEDED:
      messageObj = new Message(payload.message);
      return {
        ...state,
        messages: Collection.removeAndAdd(state.messages, messageObj),
        saving: false,
      };
    case SEND_MESSAGE_FAILED:
      return {
        ...state,
        messages: Collection.removeAndAdd(state.messages, messageObj),
        saving: false,
      };
    case MARK_MESSAGE_READ_SENT: {
      const existingMsg = Collection.get(state.messages, payload.messageId);
      if (!existingMsg) return state;
      // Create a new Message with cloned recipient_status to avoid state mutation
      messageObj = new Message({
        ...existingMsg.toPlainObject(),
        recipient_status: { ...existingMsg.recipient_status },
      });
      messageObj.markRead(payload.userId);
      return {
        ...state,
        messages: Collection.removeAndAdd(state.messages, messageObj),
      };
    }
    case RECEIVED_NEW_MESSAGE:
      messageObj = new Message(payload.message);
      return {
        ...state,
        messages: Collection.add(state.messages, messageObj),
      };
    case MESSAGE_READ_BY_SOMEONE: {
      const existingMsg = Collection.get(state.messages, payload.messageId);
      if (!existingMsg) return state;
      // Create a new Message with cloned recipient_status to avoid state mutation
      messageObj = new Message({
        ...existingMsg.toPlainObject(),
        recipient_status: { ...existingMsg.recipient_status },
      });
      messageObj.readByOtherUser(payload.userId);
      return {
        ...state,
        messages: Collection.removeAndAdd(state.messages, messageObj),
      };
    }
    default:
      return state;
  }
}
